import { motion } from "framer-motion";
import { HelpCircle, CheckCircle2 } from "lucide-react";

export default function Step4MotivationQuestions({ formData, setFormData, errors, motivationalQuestions = [] }) {
  const handleChange = (questionIndex, value) => {
    setFormData((prev) => {
      const updatedAnswers = [...(prev.motivationAnswers || [])];
      updatedAnswers[questionIndex] = value;
      return { ...prev, motivationAnswers: updatedAnswers };
    });
  };

  if (!motivationalQuestions || motivationalQuestions.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3 }}
        className="p-6 bg-white rounded-xl border border-gray-200 shadow-sm sm:p-8"
      >
        <div className="flex gap-3 items-center mb-8">
          <div className="flex justify-center items-center w-10 h-10 text-white bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg shadow-md">
            <HelpCircle size={20} />
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Motivation Questions</h2>
        </div>
        <div className="py-12 text-center">
          <p className="text-gray-600">No motivation questions for this event.</p>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      className="p-6 bg-white rounded-xl border border-gray-200 shadow-sm sm:p-8"
    >
      <div className="flex gap-3 items-center mb-8">
        <div className="flex justify-center items-center w-10 h-10 text-white bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg shadow-md">
          <HelpCircle size={20} />
        </div>
        <h2 className="text-2xl font-bold text-gray-900">Motivation Questions</h2>
      </div>
      <div className="space-y-6">
        {motivationalQuestions.map((question, index) => {
          const answer = formData.motivationAnswers?.[index] || "";
          const error = errors?.[`motivation_${index}`];
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="p-4 bg-gradient-to-br from-orange-50 to-white rounded-lg border border-orange-100"
            >
              <label className="block mb-3 text-sm font-semibold text-gray-900">
                {question.question} <span className="text-red-500">*</span>
              </label>
              {question.type === "free_text" ? (
                <textarea
                  value={answer}
                  onChange={(e) => handleChange(index, e.target.value)}
                  rows={4}
                  className={`w-full px-4 py-3 text-gray-900 bg-white rounded-lg border transition-all outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 resize-none ${
                    error ? "bg-red-50 border-red-300" : "border-gray-300 hover:border-gray-400"
                  }`}
                  placeholder="Enter your answer..."
                />
              ) : question.type === "multiple_choice" ? (
                <div className="space-y-2">
                  {question.options?.map((option, optionIndex) => {
                    const isSelected = answer === option;
                    return (
                      <motion.button
                        key={optionIndex}
                        type="button"
                        onClick={() => handleChange(index, option)}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        className={`w-full flex gap-3 items-center p-3 text-left rounded-lg border-2 transition-all ${
                          isSelected
                            ? "text-orange-900 bg-orange-50 border-orange-500"
                            : "text-gray-700 bg-white border-gray-200 hover:border-orange-300"
                        }`}
                      >
                        <div
                          className={`flex justify-center items-center w-5 h-5 rounded-full border-2 transition-all ${
                            isSelected ? "bg-orange-500 border-orange-500" : "border-gray-300"
                          }`}
                        >
                          {isSelected && <CheckCircle2 size={14} className="text-white" />}
                        </div>
                        <span className="text-sm font-medium">{option}</span>
                      </motion.button>
                    );
                  })}
                </div>
              ) : null}
              {error && <p className="mt-2 text-sm text-red-500">{error}</p>}
            </motion.div>
          );
        })}
      </div>
    </motion.div>
  );
}
